/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmProjectIntegrationTypeData
 */
export interface CrmProjectIntegrationTypeData {
    /**
     * 
     * @type {string}
     * @memberof CrmProjectIntegrationTypeData
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectIntegrationTypeData
     */
    name?: string;
}

/**
 * Check if a given object implements the CrmProjectIntegrationTypeData interface.
 */
export function instanceOfCrmProjectIntegrationTypeData(value: object): value is CrmProjectIntegrationTypeData {
    return true;
}

export function CrmProjectIntegrationTypeDataFromJSON(json: any): CrmProjectIntegrationTypeData {
    return CrmProjectIntegrationTypeDataFromJSONTyped(json, false);
}

export function CrmProjectIntegrationTypeDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectIntegrationTypeData {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CrmProjectIntegrationTypeDataToJSON(json: any): CrmProjectIntegrationTypeData {
    return CrmProjectIntegrationTypeDataToJSONTyped(json, false);
}

export function CrmProjectIntegrationTypeDataToJSONTyped(value?: CrmProjectIntegrationTypeData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'name': value['name'],
    };
}

